import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import WhyUs from "../components/WhyUs";
import ServiceArea from "../components/ServiceArea";
import OrderForm from "../components/OrderForm";
import Reviews from "../components/Reviews";
import CallNowFab from "../components/CallNowFab";
import ShareButton from "../components/ShareButton";
import Footer from "../components/Footer";
import { Phone, Flame } from "lucide-react";

export default function Landing() {
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    api.get("/pricing").then(({ data }) => setPricing(data)).catch(() => {});
  }, []);

  return (
    <>
      <Navbar />
      <Hero />

      {/* Marquee strip */}
      <div className="bg-brand-navy text-white overflow-hidden border-b-4 border-brand-red" data-testid="marquee-strip">
        <div className="flex whitespace-nowrap animate-marquee font-heading py-3 text-lg">
          {Array.from({ length: 2 }).map((_, r) => (
            <div key={r} className="flex gap-12 pr-12">
              {["RELIABLE", "AFFORDABLE", "FAST", "24/7 EMERGENCY", "LICENSED & INSURED", "FAMILY OWNED"].map((t,i)=>(
                <span key={`${r}-${i}`} className="flex items-center gap-12">
                  <span className="text-brand-gold">{t}</span>
                  <Flame size={16} className="text-brand-red" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <WhyUs />

      {/* Pricing section — contact for a competitive quote */}
      <section
        id="pricing"
        className="relative py-24 md:py-32 overflow-hidden"
        data-testid="pricing-section"
        style={{ background: "linear-gradient(180deg, #DCE9F3 0%, #B7D5EB 100%)" }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-6 relative">
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_heat-dispatch/artifacts/r66mkov0_image.png"
                alt="McFly's Fuel Inc. heating oil delivery truck"
                className="relative w-full h-auto object-contain"
                style={{ mixBlendMode: "multiply" }}
              />
            </div>
          </div>

          <div className="md:col-span-6">
            <div className="relative inline-block mb-6">
              <div className="bg-brand-red text-white px-6 py-3 border-2 border-brand-navy shadow-[6px_6px_0_#0A1128] -rotate-1">
                <div className="font-heading text-2xl sm:text-3xl tracking-tight" style={{ textShadow: "2px 2px 0 #0A1128" }}>
                  COMPETITIVE <span className="text-brand-gold">PRICES</span>
                </div>
              </div>
            </div>

            <h2 className="font-heading text-4xl md:text-5xl leading-[1.05] mb-6 text-brand-navy" data-testid="pricing-heading">
              Call for a fresh quote — <span className="text-brand-red">every time.</span>
            </h2>
            <p className="text-brand-navy/80 leading-relaxed mb-8">
              Heating oil prices change daily with the market. Skip the guesswork — call or request a quote online and we'll give you our best rate for the day. No hidden fees, no surprise surcharges.
            </p>

            <div className="flex flex-wrap gap-3">
              <a
                href="tel:6313723526"
                className="inline-flex items-center gap-2 bg-brand-red hover:bg-brand-redDark text-white px-6 py-3.5 font-heading tracking-wide border-2 border-brand-navy shadow-[5px_5px_0_#0A1128] hover:shadow-[8px_8px_0_#0A1128] hover:-translate-x-1 hover:-translate-y-1 transition-all"
                data-testid="pricing-call-cta"
              >
                <Phone size={18} /> Call for a Quote
              </a>
              <a
                href="#order"
                className="inline-flex items-center gap-2 bg-white hover:bg-brand-gold text-brand-navy px-6 py-3.5 font-heading tracking-wide border-2 border-brand-navy transition-colors"
                data-testid="pricing-request-cta"
              >
                Request Online
              </a>
            </div>
          </div>
        </div>
      </section>

      <ServiceArea />
      <OrderForm />
      <Reviews />

      {/* Big phone CTA */}
      <section className="relative bg-brand-red text-white py-20 border-y-4 border-brand-navy" data-testid="call-cta-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-brand-gold mb-4 font-heading">Prefer to talk to a human?</div>
          <a
            href="tel:6313723526"
            className="inline-flex items-center gap-4 font-heading text-5xl md:text-7xl hover:text-brand-gold transition-colors"
            style={{ textShadow: "3px 3px 0 #0A1128" }}
            data-testid="big-phone-cta"
          >
            <Phone size={44} /> 631-372-3526
          </a>
          <p className="mt-4 text-white/90 font-heading tracking-[0.2em] text-sm">RESIDENTIAL DELIVERY · 24/7 EMERGENCY LINE</p>
        </div>
      </section>

      <Footer />
      <CallNowFab />
      <ShareButton />
    </>
  );
}
